var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('p',{staticClass:"text-info"},[_vm._v("Hello World")]),_vm._v(" "),_vm._l((_vm.results),function(result){return _c('div',{staticClass:"columns medium-3"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-divider"},[_vm._v("\n        "+_vm._s(result.name)+"\n      ")]),_vm._v(" "),_c('div',{staticClass:"card-section"},[_c('p',[_vm._v(_vm._s(result.email)+".")])])])])})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7b62a4b0","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Dashboard.vue
// module id = 390
// module chunks = 1